import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportTable from "../components/ReportTable";
import PageHeader from "../components/PageHeader";
import DateRangeFilter from "../components/DateRangeFilter";
import { Row } from "jspdf-autotable";
import Loader from "../components/Loader";
import {
  fetchLeaveList,
  createLeaveEntry,
  getLeaveEntryById,
  updateLeaveEntry,
  checkDeleteLeaveEntry,
  deleteLeaveEntry,
} from "../redux/Approval/LeaveApprovalActions";
import Pagination from "../components/Pagination";
import SkSelect from "../components/SkSelect";
import SkDatePicker from "../components/SkDatePicker";
import moment from "moment-timezone";
import { formatWithTimeZone } from "../utils/common";
import {
  selectLeaveEntryData,
  selectLeaveEntryLoading,
  selectSelectedLeaveEntry,
  selectDeleteMessage,
  seletctLeaveRequestMeta,
} from "../redux/Approval/LeaveApprovalSelector";
import "../assets/css/leaverequest.css";
// import { toDate } from "date-fns";
// import { newDate } from "react-datepicker/dist/dist/date_utils.js";

const PERIOD_OPTIONS = [
  { value: "Full Day", label: "Full Day" },
  { value: "First Half", label: "First Half" },
  { value: "Second Half", label: "Second Half" },
];

const columns = [
  {
    key: "action",
    label: "Action",
  },
  {
    key: "approval",
    label: "Approval",
    filterType: "select",
    filterOptions: [
      { value: "Pending", label: "Pending" },
      { value: "All", label: "All" },
      { value: "Approved", label: "Approved" },
      { value: "Rejected", label: "Rejected" },
    ],
  },
  {
    key: "leaveEntryDate",
    label: "Leave Entry Date",
  },
  {
    key: "period",
    label: "Period",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "Full Day", label: "Full Day" },
      { value: "First Half", label: "First Half" },
      { value: "Second Half", label: "Second Half" },
    ],
  },
  {
    key: "fromDate",
    label: "From Date",
  },
  {
    key: "toDate",
    label: "To Date",
  },
  {
    key: "totalLeaveDays",
    label: "Total Leave Days",
  },
  {
    key: "reason",
    label: "Reason",
    filterType: "text",
  },
];

function LeaveEntry() {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));

  const leaveEntryList = useSelector(selectLeaveEntryData);
  const leaveMeta = useSelector(seletctLeaveRequestMeta);
  console.log("leaveEntryList:", leaveEntryList);
  console.log("Is Array:", Array.isArray(leaveEntryList));

  const loading = useSelector(selectLeaveEntryLoading);
  const deleteMessage = useSelector(selectDeleteMessage);

  const [showAddModal, setShowAddModal] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [filters, setFilters] = useState({
    ApprovalStatus: "Pending",
    Period: "",
    Reason: "",
  });
  const handleHeaderFilterChange = useCallback((cf) => {
    console.log("Filter Object:", cf);
    console.log("Approval Value:", cf.approval);

    setFilters((prev) => ({
      ...prev,
      ApprovalStatus: cf.approval?.value ?? "",
      Period: cf.period?.value ?? "",
      Reason: cf.reason?.value ?? "",
    }));

    setCurrentPage(1);
  }, []);

  const buildFilterPayload = useCallback(() => {
    const payload = {
      UserCode: user.userId,
      PageNumber: currentPage,
      PageSize: pageSize,
    };
    console.log("Filter Payload:", payload);
    console.log("ApprovalStatus:", filters.ApprovalStatus);
    switch (filters.ApprovalStatus) {
      case "Approved":
        payload.Approval = 1;
        break;

      case "Rejected":
        payload.Reject = 1;
        break;

      case "Pending":
        payload.Pending = 1;
        break;

      case "All":
      default:
        break;
    }

    if (filters.Period) {
      payload.Period = filters.Period;
    }

    if (filters.Reason?.trim()) {
      payload.Reason = filters.Reason.trim();
    }

    return payload;
  }, [filters, currentPage, pageSize, user.userId]);

  const [addFormData, setAddFormData] = useState({
    LeaveEntryDate: "",
    Period: "",
    FromDate: "",
    ToDate: "",
    TotalLeaveDays: "",
    Reason: "",
  });

  const [editFormData, setEditFormData] = useState({
    LeaveEntryDate: "",
    Period: "",
    FromDate: "",
    ToDate: "",
    TotalLeaveDays: "",
    Reason: "",
  });

  const [errors, setErrors] = useState({
    LeaveEntryDate: "",
    Period: "",
    FromDate: "",
    ToDate: "",
    TotalLeaveDays: "",
    Reason: "",
  });

  const [editErrors, setEditErrors] = useState({
    LeaveEntryDate: "",
    Period: "",
    FromDate: "",
    ToDate: "",
    TotalLeaveDays: "",
    Reason: "",
  });

  const validateLeaveEntryDate = (value) => {
    if (!value) return "Leave Entry Data is required";
    return "";
  };

  const validatePeriod = (value) => {
    if (!value) return "Period is required";

    const periods = ["First Half", "Second Half", "Full Day"];
    if (!periods.includes(value)) {
      return "Invalid period";
    }
    return "";
  };

  const validateFromDate = (fromDate, leaveEntryDate) => {
    if (!fromDate) return "From Date is required.";

    if (leaveEntryDate && new Date(fromDate) < new Date(leaveEntryDate)) {
      return "From Date should be on or after Leave Entry Date.";
    }

    return "";
  };

  const validateToDate = (toDate, fromDate, leaveEntryDate) => {
    if (!toDate) return "To Date is required.";

    if (leaveEntryDate && new Date(toDate) < new Date(leaveEntryDate)) {
      return "To Date should be on or after From Date.";
    }

    if (fromDate && new Date(toDate) < new Date(fromDate)) {
      return "To Date should be greater than or equal to From Date.";
    }

    return "";
  };
  const validateLeaveDays = (value) => {
    if (!value) return "Total Leave days is required.";

    if (Number(value) <= 0) {
      return "Total Leave Days should be greater than 0";
    }
    return "";
  };

  const validateReason = (value) => {
    const reason = value.trim();

    if (!reason) {
      return "Reason is required.";
    }

    if (reason.length < 3) {
      return "Reason must be at least 3 characters.";
    }

    if (reason.length > 200) {
      return "Reason cannot exceed 200 characters.";
    }

    return "";
  };

  const calculateLeaveDays = (fromDate, toDate, period) => {
    if (!fromDate || !toDate || !period) return "";

    const from = new Date(fromDate);
    const to = new Date(toDate);

    if (to < from) return "";

    const diff = Math.floor((to - from) / (1000 * 60 * 60 * 24)) + 1;

    switch (period) {
      case "Full Day":
        return diff;

      case "First Half":
      case "Second Half":
        return diff * 0.5;

      default:
        return "";
    }

    return "";
  };
  useEffect(() => {
    const days = calculateLeaveDays(
      addFormData.FromDate,
      addFormData.ToDate,
      addFormData.Period,
    );

    setAddFormData((prev) => ({
      ...prev,
      TotalLeaveDays: days,
    }));
  }, [addFormData.FromDate, addFormData.ToDate, addFormData.Period]);

  useEffect(() => {
    const days = calculateLeaveDays(
      editFormData.FromDate,
      editFormData.ToDate,
      editFormData.Period,
    );

    setEditFormData((prev) => ({
      ...prev,
      TotalLeaveDays: days,
    }));
  }, [editFormData.FromDate, editFormData.ToDate, editFormData.Period]);
  const validate = () => {
    const newErrors = {
      LeaveEntryDate: validateLeaveEntryDate(addFormData.LeaveEntryDate),
      Period: validatePeriod(addFormData.Period),
      FromDate: validateFromDate(
        addFormData.FromDate,
        addFormData.LeaveEntryDate,
      ),
      ToDate: validateToDate(
        addFormData.ToDate,
        addFormData.FromDate,
        addFormData.LeaveEntryDate,
      ),
      TotalLeaveDays: validateLeaveDays(addFormData.TotalLeaveDays),
      Reason: validateReason(addFormData.Reason),
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const validateEdit = () => {
    const newErrors = {
      LeaveEntryDate: validateLeaveEntryDate(editFormData.LeaveEntryDate),
      Period: validatePeriod(editFormData.Period),
      FromDate: validateFromDate(
        editFormData.FromDate,
        editFormData.LeaveEntryDate,
      ),
      ToDate: validateToDate(
        editFormData.ToDate,
        editFormData.FromDate,
        editFormData.leaveEntryDate,
      ),
      TotalLeaveDays: validateLeaveDays(editFormData.TotalLeaveDays),
      Reason: validateReason(editFormData.Reason),
    };

    setEditErrors(newErrors);

    return Object.values(newErrors).every((err) => err === "");
  };
  const handleAddLeave = async () => {
    console.log("User:", user);

    if (!validate()) return;

    const payload = {
      LeaveEntryDate: addFormData.LeaveEntryDate,
      UserCode: user.userId,
      Period: addFormData.Period,
      FromDate: addFormData.FromDate,
      ToDate: addFormData.ToDate,
      TotalLeaveDays: Number(addFormData.TotalLeaveDays),
      Reason: addFormData.Reason,
    };
    console.log("Payload:", payload);
    const result = await dispatch(createLeaveEntry(payload));
    console.log(result);
    dispatch(
      fetchLeaveList({
        UserCode: user.userId,
        CurrentPage: currentPage,
        PageSize: pageSize,
      }),
    );
    setShowAddModal(false);

    setAddFormData({
      LeaveEntryDate: "",
      UserCode: "",
      Period: "",
      FromDate: "",
      ToDate: "",
      TotalLeaveDays: "",
      Reason: "",
    });
  };

  const handleUpdateLeave = async () => {
    const payload = {
      LeaveEntryCode: selectedLeave.LeaveEntryCode,
      UserCode: selectedLeave.UserCode,
      LeaveEntryDate: editFormData.LeaveEntryDate,
      Period: editFormData.Period,
      FromDate: editFormData.FromDate,
      ToDate: editFormData.ToDate,
      TotalLeaveDays: Number(editFormData.TotalLeaveDays),
      Reason: editFormData.Reason,
    };

    await dispatch(
      updateLeaveEntry({
        id: selectedLeave.LeaveEntryCode,
        payload,
      }),
    );
    dispatch(
      fetchLeaveList({
        UserCode: user.userId,
        CurrentPage: currentPage,
        PageSize: pageSize,
      }),
    );
    setShowEditModal(false);
  };
  const resetAddForm = () => {
    setAddFormData({
      LeaveEntryDate: "",
      Period: "",
      FromDate: "",
      ToDate: "",
      TotalLeaveDays: "",
      Reason: "",
    });
    setErrors({
      LeaveEntryDate: "",
      Period: "",
      FromDate: "",
      ToDate: "",
      TotalLeaveDays: "",
      Reason: "",
    });

    setShowAddModal(false);
  };

  useEffect(() => {
    dispatch(
      fetchLeaveList({
        // UserCode: user.userId,
        ...buildFilterPayload(),
      }),
    );
  }, [dispatch, buildFilterPayload]);

  const handleEdit = async (id) => {
    console.log("Clicked ID:", id);
    await dispatch(getLeaveEntryById(id));

    setShowEditModal(true);
  };

  const openDeletePopup = async (id) => {
    setDeleteId(id);

    const result = await dispatch(checkDeleteLeaveEntry(id));

    if (checkDeleteLeaveEntry.fulfilled.match(result)) {
      setShowDeleteModal(true);
    }
  };
  const handleDelete = async () => {
    const result = await dispatch(deleteLeaveEntry(deleteId));

    if (deleteLeaveEntry.fulfilled.match(result)) {
      setShowDeleteModal(false);
      setDeleteId(null);

      dispatch(
        fetchLeaveList({
          UserCode: user.userId,
          PageNumber: currentPage,
          PageSize: pageSize,
        }),
      );
    }
  };
  const selectedLeave = useSelector(selectSelectedLeaveEntry);
  console.log("selectedLeave:", selectedLeave);

  useEffect(() => {
    if (selectedLeave) {
      setEditFormData({
        LeaveEntryDate: formatWithTimeZone(
          selectedLeave.LeaveEntryDate,
          "YYYY-MM-DD",
        ),
        Period: selectedLeave.Period,
        FromDate: formatWithTimeZone(selectedLeave.FromDate, "YYYY-MM-DD"),
        ToDate: formatWithTimeZone(selectedLeave.ToDate, "YYYY-MM-DD"),
        TotalLeaveDays: selectedLeave.TotalLeaveDays,
        Reason: selectedLeave.Reason,
      });
    }
  }, [selectedLeave]);
  const data =
    leaveEntryList?.map((item, index) => ({
      id: item.LeaveEntryCode,

      sno: index + 1,

      // leaveEntryNo: item.LeaveEntryNo,
      approval: (
        <button
          className={
            item.Approval
              ? "status-btn approve-status"
              : item.Reject
                ? "status-btn reject-status"
                : "status-btn pending-status"
          }
        >
          {item.Approval ? "Approved" : item.Reject ? "Rejected" : "Pending"}
        </button>
      ),

      //        approval: (
      //   <button
      //     className={
      //       item.Approval
      //         ? "status-btn active-status"
      //         : "status-btn inactive-status"
      //     }
      //   >
      //     {item.Approval ? "Approved" : "Pending"}
      //   </button>
      // ),
      reject: item.Reject,

      leaveEntryDate: formatWithTimeZone(item.LeaveEntryDate, "DD-MM-yy"),
      period: item.Period,

      fromDate: formatWithTimeZone(item.FromDate, "DD-MM-yy"),

      toDate: formatWithTimeZone(item.ToDate, "DD-MM-YYYY"),

      totalLeaveDays: item.TotalLeaveDays,

      reason: item.Reason,
    })) || [];

  return (
    <>
      {loading && <Loader isLoading={loading} />}

      <div className="leave-page ">
        <PageHeader
          icon={<i className="bi bi-calendar-check"></i>}
          title="Leave Entry"
          subtitle="Manage Leave Entry"
          actions={
            <>
              <button
                className="add-shift-btn"
                onClick={() => {
                  resetAddForm();
                  setShowAddModal(true);
                }}
              >
                 + New
              </button>
            </>
          }
        />

        <div className="leave-data">
          <div className="table-container">
            <ReportTable
              columns={columns}
              data={data}
              serverSide={true}
              stickyColumns={["action"]}
              onHeaderFilterChange={handleHeaderFilterChange}
              renderActions={(row) => (
                <div className="shift-action-buttons">
                  <button
                    className="action-btn edit-btn"
                    onClick={() => handleEdit(row.id)}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    className="action-btn delete-btn"
                    onClick={() => openDeletePopup(row.id)}
                  >
                    <i className="bi bi-trash-fill"></i>
                  </button>
                </div>
              )}
            />
          </div>

          <Pagination
            currentPage={currentPage}
            totalCount={leaveMeta?.totalRecords || 0}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            onPageSizeChange={(size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
          />
        </div>

        {showAddModal && (
          <div className="se-overlay" onClick={resetAddForm}>
            <div className="se-modal" onClick={(e) => e.stopPropagation()}>
              {/* Header */}
              <div className="se-modal__header">
                <div>
                  <h3>Add Leave Entry</h3>
                  <p className="se-modal__subtitle">
                    Create your leave request
                  </p>
                </div>

                <button className="se-close" onClick={resetAddForm}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              {/* Body */}
              <div className="se-modal__body">
                <section className="se-section">
                  <h4 className="se-section__title">Leave Details</h4>

                  <div className="se-grid">
                    <div className="se-field">
                      <label>Leave Entry Date</label>

                      <SkDatePicker
                        size="md"
                        block
                        invalid={!!errors.LeaveEntryDate}
                        value={addFormData.LeaveEntryDate}
                        onChange={(value) => {
                          setAddFormData({
                            ...addFormData,
                            LeaveEntryDate: value,
                          });

                          setErrors({
                            ...errors,
                            LeaveEntryDate: validateLeaveEntryDate(value),
                          });
                        }}
                      />

                      {errors.LeaveEntryDate && (
                        <p className="error-text">{errors.LeaveEntryDate}</p>
                      )}
                    </div>

                    {/* From Date */}
                    <div className="se-field">
                      <label>From Date</label>

                      <SkDatePicker
                        size="md"
                        block
                        invalid={!!errors.FromDate}
                        value={addFormData.FromDate}
                        onChange={(value) => {
                          setAddFormData({
                            ...addFormData,
                            FromDate: value,
                          });

                          setErrors({
                            ...errors,
                            FromDate: validateFromDate(
                              value,
                              addFormData.LeaveEntryDate,
                            ),
                          });
                        }}
                      />

                      {errors.FromDate && (
                        <p className="error-text">{errors.FromDate}</p>
                      )}
                    </div>

                    {/* To Date */}
                    <div className="se-field">
                      <label>To Date</label>

                      <SkDatePicker
                        size="md"
                        block
                        invalid={!!errors.ToDate}
                        minDate={addFormData.FromDate}
                        value={addFormData.ToDate}
                        onChange={(value) => {
                          setAddFormData({
                            ...addFormData,
                            ToDate: value,
                          });

                          setErrors({
                            ...errors,
                            ToDate: validateToDate(
                              value,
                              addFormData.FromDate,
                              addFormData.LeaveEntryDate,
                            ),
                          });
                        }}
                      />

                      {errors.ToDate && (
                        <p className="error-text">{errors.ToDate}</p>
                      )}
                    </div>

                    {/* Period */}
                    <div className="se-field">
                      <label>Period</label>

                      <SkSelect
                        size="md"
                        width="100%"
                        placeholder="Select Period"
                        invalid={!!errors.Period}
                        value={addFormData.Period}
                        options={PERIOD_OPTIONS}
                        onChange={(value) => {
                          setAddFormData({
                            ...addFormData,
                            Period: value,
                          });

                          setErrors({
                            ...errors,
                            Period: validatePeriod(value),
                          });
                        }}
                      />

                      {errors.Period && (
                        <p className="error-text">{errors.Period}</p>
                      )}
                    </div>

                    {/* Total Leave Days */}
                    <div className="se-field">
                      <label>Total Leave Days</label>

                      <input
                        type="number"
                        readOnly
                        className={`se-input ${
                          errors.TotalLeaveDays ? "se-input--error" : ""
                        }`}
                        value={addFormData.TotalLeaveDays}
                      />

                      {errors.TotalLeaveDays && (
                        <p className="error-text">{errors.TotalLeaveDays}</p>
                      )}
                    </div>

                    {/* Reason */}
                    <div className="se-field se-field--full">
                      <label>Reason</label>

                      <textarea
                        rows={8}
                        className={`se-input ${
                          errors.Reason ? "se-input--error" : ""
                        }`}
                        value={addFormData.Reason}
                        onChange={(e) => {
                          const value = e.target.value;

                          setAddFormData({
                            ...addFormData,
                            Reason: value,
                          });

                          setErrors({
                            ...errors,
                            Reason: validateReason(value),
                          });
                        }}
                      />

                      {errors.Reason && (
                        <p className="error-text">{errors.Reason}</p>
                      )}
                    </div>
                  </div>
                </section>
              </div>

              {/* Footer */}
              <div className="se-modal__footer">
                <button className="se-btn se-btn--ghost" onClick={resetAddForm}>
                  Cancel
                </button>

                <button
                  className="se-btn se-btn--primary"
                  onClick={handleAddLeave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {showEditModal && (
          <div className="se-overlay" onClick={() => setShowEditModal(false)}>
            <div className="se-modal" onClick={(e) => e.stopPropagation()}>
              {/* Header */}
              <div className="se-modal__header">
                <div>
                  <h3>Edit Leave Entry</h3>
                  <p className="se-modal__subtitle">
                    Update your leave request
                  </p>
                </div>

                <button
                  className="se-close"
                  onClick={() => setShowEditModal(false)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              {/* Body */}
              <div className="se-modal__body">
                <section className="se-section">
                  <h4 className="se-section__title">Leave Details</h4>

                  <div className="se-grid">
                    {/* Leave Entry Date */}
                    <div className="se-field">
                      <label>Leave Entry Date</label>

                      <SkDatePicker
                        size="md"
                        block
                        invalid={!!editErrors.LeaveEntryDate}
                        value={editFormData.LeaveEntryDate}
                        onChange={(value) => {
                          setEditFormData({
                            ...editFormData,
                            LeaveEntryDate: value,
                          });

                          setEditErrors({
                            ...editErrors,
                            LeaveEntryDate: validateLeaveEntryDate(value),
                          });
                        }}
                      />

                      {editErrors.LeaveEntryDate && (
                        <p className="error-text">
                          {editErrors.LeaveEntryDate}
                        </p>
                      )}
                    </div>

                    {/* Period */}
                    <div className="se-field">
                      <label>Period</label>

                      <SkSelect
                        size="md"
                        width="100%"
                        placeholder="Select Period"
                        invalid={!!editErrors.Period}
                        value={editFormData.Period}
                        options={PERIOD_OPTIONS}
                        onChange={(value) => {
                          setEditFormData({
                            ...editFormData,
                            Period: value,
                          });

                          setEditErrors({
                            ...editErrors,
                            Period: validatePeriod(value),
                          });
                        }}
                      />

                      {editErrors.Period && (
                        <p className="error-text">{editErrors.Period}</p>
                      )}
                    </div>

                    {/* From Date */}
                    <div className="se-field">
                      <label>From Date</label>

                      <SkDatePicker
                        size="md"
                        block
                        invalid={!!editErrors.FromDate}
                        value={editFormData.FromDate}
                        onChange={(value) => {
                          setEditFormData({
                            ...editFormData,
                            FromDate: value,
                          });

                          setEditErrors({
                            ...editErrors,
                            FromDate: validateFromDate(
                              value,
                              editFormData.LeaveEntryDate,
                            ),
                          });
                        }}
                      />

                      {editErrors.FromDate && (
                        <p className="error-text">{editErrors.FromDate}</p>
                      )}
                    </div>

                    {/* To Date */}
                    <div className="se-field">
                      <label>To Date</label>

                      <SkDatePicker
                        size="md"
                        block
                        invalid={!!editErrors.ToDate}
                        minDate={editFormData.FromDate}
                        value={editFormData.ToDate}
                        onChange={(value) => {
                          setEditFormData({
                            ...editFormData,
                            ToDate: value,
                          });

                          setEditErrors({
                            ...editErrors,
                            ToDate: validateToDate(
                              value,
                              editFormData.FromDate,
                              editFormData.leaveEntryDate,
                            ),
                          });
                        }}
                      />

                      {editErrors.ToDate && (
                        <p className="error-text">{editErrors.ToDate}</p>
                      )}
                    </div>

                    {/* Total Leave Days */}
                    <div className="se-field">
                      <label>Total Leave Days</label>

                      <input
                        type="number"
                        readOnly
                        className={`se-input ${
                          editErrors.TotalLeaveDays ? "se-input--error" : ""
                        }`}
                        value={editFormData.TotalLeaveDays}
                      />

                      {editErrors.TotalLeaveDays && (
                        <p className="error-text">
                          {editErrors.TotalLeaveDays}
                        </p>
                      )}
                    </div>
                    {/* Reason */}
                    <div className="se-field se-field--full">
                      <label>Reason</label>

                      <textarea
                        rows={3}
                        className={`se-input ${
                          editErrors.Reason ? "se-input--error" : ""
                        }`}
                        value={editFormData.Reason}
                        onChange={(e) => {
                          const value = e.target.value;

                          setEditFormData({
                            ...editFormData,
                            Reason: value,
                          });

                          setEditErrors({
                            ...editErrors,
                            Reason: validateReason(value),
                          });
                        }}
                      />

                      {editErrors.Reason && (
                        <p className="error-text">{editErrors.Reason}</p>
                      )}
                    </div>
                  </div>
                </section>
              </div>

              {/* Footer */}
              <div className="se-modal__footer">
                <button
                  className="se-btn se-btn--ghost"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="se-btn se-btn--primary"
                  onClick={handleUpdateLeave}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}

        {showDeleteModal && (
          <div className="se-overlay" onClick={() => setShowDeleteModal(false)}>
            <div className="se-modal" onClick={(e) => e.stopPropagation()}>
              <div className="se-modal__header">
                <div>
                  <h3>Delete Leave Entry</h3>
                  <p className="se-modal__subtitle">
                    Confirm before deleting this leave entry
                  </p>
                </div>

                <button
                  className="se-close"
                  onClick={() => setShowDeleteModal(false)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              <div className="se-modal__body">
                <section className="se-section">
                  <h4 className="se-section__title">Confirmation</h4>

                  <p
                    style={{
                      margin: 0,
                      color: "#475569",
                      lineHeight: "1.7",
                      fontSize: "15px",
                    }}
                  >
                    {deleteMessage}
                  </p>
                </section>
              </div>

              <div className="se-modal__footer">
                <button
                  className="se-btn se-btn--ghost"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setDeleteId(null);
                  }}
                >
                  No
                </button>

                <button
                  className="se-btn se-btn--primary"
                  onClick={handleDelete}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default LeaveEntry;
